var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.451 3a3.41 3.41 0 0 0-2.372.952 3.2 3.2 0 0 0-.982 2.298v11.5a3.2 3.2 0 0 0 .982 2.298A3.41 3.41 0 0 0 6.451 21h11.872a3.41 3.41 0 0 0 2.372-.952 3.2 3.2 0 0 0 .982-2.298v-6.389a.706.706 0 0 0-.716-.694.705.705 0 0 0-.717.694v6.39c0 .493-.202.966-.563 1.316-.36.349-.849.545-1.358.545H6.45c-.51 0-.998-.196-1.359-.545a1.833 1.833 0 0 1-.562-1.317V6.25c0-.494.202-.967.562-1.317.36-.349.85-.545 1.36-.545h6.595c.395 0 .716-.31.716-.694A.706.706 0 0 0 13.047 3H6.45Zm15.177.44A.717.717 0 0 0 20.96 3H16.71a.706.706 0 0 0-.717.694c0 .383.321.694.717.694h2.521l-7.327 7.098a.679.679 0 0 0 0 .982.733.733 0 0 0 1.014 0l7.326-7.098v2.489c0 .383.321.694.717.694.396 0 .716-.311.716-.694V3.659l-.05-.219Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/new_tab.73053887e646348716f27ab0c28fd7a7.svg";
export { ForwardRef as ReactComponent };